$(function(){
$("#selectPackageTracker").click(()=>{
    if($("#selectPackageTracker img.down_arrows").hasClass("custom_select_active")){
      $("#selectPackageTracker img.down_arrows").removeClass("custom_select_active")
    }else {
      $("#selectPackageTracker img.down_arrows").addClass("custom_select_active")
    }
  	$("#PackageTrackerList").stop().slideToggle(300)
})

  $("#PackageTrackerList").children().click(function(e){
    
    console.log($("form.search-header input[type='search']").val())
//     console.log()
    let toSearchLink;
    switch ($(this).attr("value")) {
    case "1":
        toSearchLink = "https://www.aramex.com.au/tools/track?l=";
        break;
    case "2":
        toSearchLink = "https://t.17track.net/en#nums=";
         break;
    case "3":
        toSearchLink = "http://www.yitongexpress.com/TrackResult.aspx?ctl00$txtTrack1=";
         break;
    case "4":
        toSearchLink = "https://t.17track.net/ru#nums=";
         break;
    case "5":
        toSearchLink = "http://47.52.146.142/podtrack/Details.aspx?ID=";
         break;
    case "6":
        toSearchLink = "http://qywl.kingtrans.cn/WebTrack?action=list&bills=";
         break;
    case "7":
        toSearchLink = "http://47.112.6.60:8712";
        break;
    case "8":
        toSearchLink = "https://www.17track.net/en#nums=";
        break;
    case "9":
        toSearchLink = "http://47.106.221.71/cgi-bin/GInfo.dll?EmmisTrack?cno=";
        break;
    case "10":
        toSearchLink = "http://www.j-net.cn/service/track?version=&number=";
        break;
    case "11":
        toSearchLink = "http://www.j-net.cn/service/track?version=&number=";
        break;
    case "12":
        toSearchLink = "http://www.j-net.cn/service/track?version=&number=";
        break;
    case "13":
        toSearchLink = "https://www.17track.net/en#nums=";
        break;
    case "14":
        toSearchLink = "http://120.24.176.176:8082/en/trackIndex.htm?documentCode=";
        break;
    case "15":
        toSearchLink = "http://www.j-net.cn/service/track?version=&number=";
        break;
    case "16":
        toSearchLink = "https://webtrack.dhlglobalmail.com/?trackingnumber=";
        break;
	}
    let linkPackUrl
    if(toSearchLink.indexOf("=")>=0){
    	linkPackUrl = toSearchLink+$("#ExpressInquirySearchInput").val()
    }else{
    	linkPackUrl = toSearchLink
    }
    window.open(linkPackUrl);
  })

})
$(function(){
//   var url = window.location.pathname;
//   $("#custom_wherehost_select select").find("option").each(function(){
//     let oVal = $(this).val()
//     if(url.indexOf(oVal)>=0 && oVal!="" && oVal){
//       $("#custom_wherehost_select select").val(url)
//     }
//   })
  $("#custom_wherehost_select select").change(function(e){
    window.location.href = $(this).val()
  })
})



function Accordion(option) {
  let el = option.el||".accordion_wrapper";
  let autoClose = option.autoClose||false;
  let defaultIndex = option.defaultIndex;
  let time = option.time||200;
  let queryAccordionAre = $(el);

  let queryLableList = queryAccordionAre.find(".accordion_section .accordion_section_title")
  for (let i = 0; i < queryLableList.length; i++) {
    queryLableList[i].onclick=()=>{
      handelChange(i)
    }
  }
  if(defaultIndex!=null&&defaultIndex!=undefined&&!isNaN(parseInt(defaultIndex))){
    openDropDown(parseInt(defaultIndex),autoClose)
  }
  function handelChange(index) {
    let queryGroupList = queryAccordionAre.find(".accordion_section")
    if($(queryGroupList[index]).hasClass('active')){
      closeIndexDropDown(index)
    }else {
      openDropDown(index,autoClose)
    }
  }
  function openDropDown(index,closeOther) {
    let queryGroupList = queryAccordionAre.find(".accordion_section")
    if(closeOther){
      closeAllDropDown()
    }
    $(queryGroupList[index]).addClass("active")
    $(queryGroupList[index]).find(".accordion_section_list").slideDown(time)
  }
  function closeIndexDropDown(index) {
    let queryGroupList = queryAccordionAre.find(".accordion_section")
    $(queryGroupList[index]).removeClass("active")
    $(queryGroupList[index]).find(".accordion_section_list").slideUp(time);
  }
  function closeAllDropDown() {
    let queryGroupList = queryAccordionAre.find(".accordion_section")
    queryGroupList.removeClass('active')
    queryGroupList.find('.accordion_section_list').slideUp(time)
  }
  return{
    openDropDown:openDropDown,
    closeIndexDropDown:closeIndexDropDown,
    closeAllDropDown:closeAllDropDown
  }
}

// Confirm功能
function customConfirm(text,title,option={}){
    return new Promise((resolve, reject) => {
        let confirmButtonText = option.confirmButtonText||"OK"
        let cancelButtonText = option.cancelButtonText||"Cancel"

        let confirmBack = document.createElement("div");
        confirmBack.setAttribute("class","confirm_back_mask")
        document.body.append(confirmBack)

        let confirmPanel = document.createElement("div");
        confirmPanel.setAttribute("class","confirm_panel")
        confirmBack.append(confirmPanel)
        if(title){
            let confirmTitle = document.createElement("div");
            confirmTitle.setAttribute("class","confirm_title")
            confirmTitle.innerText=title
            confirmPanel.append(confirmTitle)
        }
        let confirmText = document.createElement("div");
        confirmText.setAttribute("class","confirm_text")
        confirmText.innerText=text

        confirmPanel.append(confirmText)

        let confirmFooter = document.createElement("div");
        confirmFooter.setAttribute("class","confirm_footer")
        let cancelButton = document.createElement("button");
        let confirmButton = document.createElement("button");
        cancelButton.setAttribute("class","center_btn")
        cancelButton.innerText=cancelButtonText
        confirmButton.setAttribute("class","confirm_btn")
        confirmButton.innerText=confirmButtonText

        confirmFooter.append(cancelButton)
        confirmFooter.append(confirmButton)
        console.log(confirmButton)
        confirmPanel.append(confirmFooter)

        confirmButton.onclick=(e)=>{
            removeEl()
            resolve()
        }
        cancelButton.onclick=(e)=>{
            removeEl()
            reject()
        }
        confirmBack.onclick=(e)=>{
            removeEl()
            reject()
        }
        confirmPanel.onclick=(e)=>{
            e.stopPropagation()
            e.preventDefault()
        }
        function removeEl() {
            confirmBack.remove()
        }

    })
}
var $confirm = customConfirm
window["$confirm"] = $confirm
